import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { transformEntityToObject } from '@ptg-entity-management/helpers';
import { UpsertEntityDataRequest } from '@ptg-entity-management/services/models';

import { environment } from 'src/environments/environment';
import { CheckMemberExistsBySsnRequest, CheckMemberExistsBySsnResponse, ValidateSSNAndServiceHistoryRequest, ValidateSSNAndServiceHistoryResponse } from '@ptg-member/types/models';

@Injectable()
export class MemberService {
  constructor(private httpClient: HttpClient) {}

  createMember(request: UpsertEntityDataRequest): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.apiUrl}/member-portal`,
      transformEntityToObject(request)
    );
  }

  updateMember(memberId: string, cardName: string, request: UpsertEntityDataRequest): Observable<any> {
    return this.httpClient.put<any>(
      `${environment.apiUrl}/member-portal/${memberId}`,
      transformEntityToObject(request)
    );
  }

  checkMemberExists(request: CheckMemberExistsBySsnRequest): Observable<CheckMemberExistsBySsnResponse> {
    let params = new HttpParams();
    if (request.ssn) {
      params = params.append('Ssn', request.ssn);
    }
    if (request.firstName) {
      params = params.append('FirstName', request.firstName);
    }
    if (request.lastName) {
      params = params.append('LastName', request.lastName);
    }
    if (request.dateOfBirth) {
      params = params.append('DateOfBirth', request.dateOfBirth);
    }
    params = params.append('TimeZoneOffset', new Date().getTimezoneOffset());
    return this.httpClient.get<CheckMemberExistsBySsnResponse>(`${environment.apiUrl}/entities/members/exists`, { params });
  }

  validateSSNAndServiceHistoryBeforeAddMember(request: ValidateSSNAndServiceHistoryRequest): Observable<ValidateSSNAndServiceHistoryResponse> {
    let params = new HttpParams();
    params = params.append('TimeZoneOffset', new Date().getTimezoneOffset());
    params = params.append('IsNeedValidateSsn', request.isNeedValidateSsn);
    if (request.municipalityId) {
      params = params.append('MunicipalityId', request.municipalityId);
    }
    if (request.ssn) {
      params = params.append('Ssn', request.ssn);
    }
    if (request.firstName) {
      params = params.append('FirstName', request.firstName);
    }
    if (request.lastName) {
      params = params.append('LastName', request.lastName);
    }
    if (request.dateOfBirth) {
      params = params.append('DateOfBirth', request.dateOfBirth);
    }
    if (request.serviceHistoryBeginDate) {
      params = params.append('ServiceHistoryBeginDate', request.serviceHistoryBeginDate);
    }
    if (request.serviceHistoryEndDate) {
      params = params.append('ServiceHistoryEndDate', request.serviceHistoryEndDate);
    }
    
    return this.httpClient.get<ValidateSSNAndServiceHistoryResponse>(`${environment.apiUrl}/member-portal/exists`, { params });
  }
}
